import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Redirect } from 'react-router-dom'
import { injectIntl, defineMessages } from 'react-intl'
import { loadUser, clearUser } from '../../common/users/actions'
import { PageHeader, ResultsList } from '../components'

class StudentPage extends React.Component {
  componentWillMount() {
    const { match, loadUser } = this.props
    this.userId = this.props.match.params.id
    if (this.userId) {
      loadUser(match.params.id)
    }
  }

  componentWillUnmount() {
    if (this.userId) {
      this.props.clearUser()
    }
  }

  render() {
    const { userProfile, viewer, lessons, intl } = this.props
    let user = null
    const isUserProfile = this.userId && userProfile

    if (isUserProfile) {
      if (userProfile._id === viewer._id) {
        return <Redirect to="/app/user" />
      }
      user = (userProfile && userProfile.toJS())
    } else if (!this.userId && lessons) {
      user = viewer
    }

    if (!user) return null

    return (
      <div className="user-page">
        <PageHeader
          title={user.name}
        />
        {
          user.results && !!user.results.length &&
          <h3>{intl.formatMessage(messages.studentResults)}</h3>
        }
        <ResultsList
          results={user.results}
          testAsTitle
        />
      </div>
    )
  }
}

StudentPage.defaultProps = {
  match: null,
  lessons: null,
  userProfile: null,
  viewer: null,
}

StudentPage.propTypes = {
  intl: PropTypes.object.isRequired,
  userProfile: PropTypes.object,
  viewer: PropTypes.object,
  lessons: PropTypes.object,
  loadUser: PropTypes.func.isRequired,
  clearUser: PropTypes.func.isRequired,
  match: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    userProfile: state.users.current,
  }), { loadUser, clearUser }),
  injectIntl,
)

export default enhance(StudentPage)

const messages = defineMessages({
  studentResults: {
    id: 'student.page.studentResults',
    defaultMessage: 'Výsledky žiaka',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/StudentPage.js